import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { defControllerView } from '../../../utils';
import NewChatList from '../components/NewChatList';
import NewChatConfigureDialog from '../components/NewChatConfigureDialog';
import SearchAppBar from '../../../components/SearchAppBar';
import StatusBarStyle from '../../../components/StatusBarStyle';
import LoadingDialog from '../../../components/LoadingDialog';
import ErrorSnackbar from '../../../components/ErrorSnackbar';
import { HistoryType, LocationType } from '../../../types/router';
import { localize } from '../../../i18n';
import { sendCommand } from '../../../utils/mobile';

class NewChat extends PureComponent {
  constructor(...args) {
    super(...args);

    this.state = {
      search: '',
      newChatInProgress: false,
      showNoPhoneMessage: false,
      hasError: false,
    };

    this.currentReservation = null;
  }

  componentDidMount() {
    const { twilio } = this.props;
    twilio.requestSync();
  }

  async onReservationSelect(reservation) {
    this.currentReservation = reservation;

    const {
      twilio,
      data: {
        reservationsWithChats,
      },
    } = this.props;

    const {
      attributes: {
        phone,
      },
    } = reservation;

    if (reservationsWithChats.includes(reservation.id)) {
      return this.openChatDialog(reservation);
    }

    if (!(phone && phone.length)) {
      return this.setState({ showNoPhoneMessage: true });
    }

    this.setState({ newChatInProgress: true });

    try {
      await twilio.ensureChatExists(reservation.id);
      this.setState({ newChatInProgress: false });
      this.openChatDialog(reservation);
    } catch (error) {
      this.setState({
        newChatInProgress: false,
        hasError: true,
      });
      console.error(error);
    }

    return null;
  }

  reservationToChannel({ id, attributes: reservation }) {
    return {
      reservationId: id,
      guestName: reservation.name,
      room: reservation.room,
    };
  }

  openChatDialog(reservation) {
    const { twilio } = this.props;
    twilio.setActiveChannel(reservation.id);

    sendCommand('override', {
      override: 'chatMessaging',
      overrideData: {
        channel: this.reservationToChannel(reservation),
      },
    });

    // We don't know when chat screen will be visible at this point
    // to avoid frames with chat list we are free to wait some time
    _.delay(() => this.navigateBack(), 1000);
  }

  navigate(path, rest) {
    const { history } = this.props;
    history.push({
      pathname: `/access/chat${path}`,
      ...rest,
    });
  }

  returnPathname() {
    const {
      location: {
        state: {
          returnPathname,
        } = {},
      },
    } = this.props;

    return returnPathname || '/access/chat';
  }

  navigateBack() {
    const { history } = this.props;
    history.push(this.returnPathname());
  }


  hideConfigureDialog() {
    this.setState({ showNoPhoneMessage: false });
  }

  navigateToDetails({ id: reservationId }) {
    this.navigate(`/${reservationId}/details`, {
      state: { returnPathname: this.returnPathname() },
    });
  }

  retryCreateChat() {
    this.setState({ hasError: false });
    this.onReservationSelect(this.currentReservation);
  }

  render() {
    const {
      search,
      newChatInProgress,
      showNoPhoneMessage,
      hasError,
    } = this.state;
    const { data, twilio } = this.props;

    const showLoader = data.ready && data.isLoading;
    const reservations = twilio.searchReservations(search, data.reservations);

    return (
      <div>
        <StatusBarStyle color="white" barStyle="dark-content" />
        <SearchAppBar
          onSearch={term => this.setState({ search: term })}
          onNavigateBack={() => this.navigateBack()}
          isLoading={showLoader}
          placeholder={this.props.t('Search Guest Name or Room Number')}
        />

        <NewChatList
          reservations={reservations}
          onSelect={reservation => this.onReservationSelect(reservation)}
          onInfoRequested={reservation => this.navigateToDetails(reservation)}
        />

        <LoadingDialog
          open={newChatInProgress}
          title={this.props.t('Creating chat. Please wait.')}
        />

        <NewChatConfigureDialog
          open={showNoPhoneMessage}
          onCancel={() => this.hideConfigureDialog()}
        />

        <ErrorSnackbar
          open={hasError}
          onRetry={() => this.retryCreateChat()}
          onRequestClose={() => this.setState({ hasError: false })}
          message={this.props.t('Unable to create chat.')}
        />
      </div>
    );
  }
}

NewChat.propTypes = {
  location: LocationType,
  history: HistoryType,
  data: PropTypes.shape({}),
  twilio: PropTypes.shape({}),
  t: PropTypes.func.isRequired,
};

export default defControllerView('TwilioController', 'twilio')(localize(NewChat));



// WEBPACK FOOTER //
// ./src/views/chat/views/NewChat.js